import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { COUNTRY_OPTIONS } from "../../constants/countries";
import { useTranslation } from "react-i18next";

interface DemographicFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
  loading: boolean;
}

export function DemographicFields({
  profile,
  setProfile,
  readOnly,
  loading
}: DemographicFieldsProps) {
  const { t } = useTranslation(["talent", "common"]);

  return (
    <>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.personal_data.fields.gender.label")}
        </label>
        <Select
          disabled={readOnly}
          value={profile?.gender}
          onValueChange={(value) =>
            setProfile((prev: any) => ({ ...prev, gender: value }))
          }
        >
          <SelectTrigger loading={loading}>
            <SelectValue
              placeholder={t(
                "forms.sections.personal_data.fields.gender.placeholder"
              )}
            />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="male">
              {t("forms.common.gender.male")}
            </SelectItem>
            <SelectItem value="female">
              {t("forms.common.gender.female")}
            </SelectItem>
            <SelectItem value="diverse">
              {t("forms.common.gender.diverse")}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.personal_data.fields.date_of_birth.label")}{" "}
          {t("forms.common.validation.required_indicator")}
        </label>
        <Input
          id="date_of_birth"
          disabled={readOnly}
          loading={loading}
          type="date"
          value={
            profile?.date_of_birth
              ? new Date(profile.date_of_birth).toISOString().split("T")[0]
              : ""
          }
          onChange={(e) => {
            const val = e.target.value;
            setProfile((prev: any) => ({
              ...prev,
              date_of_birth: val ? new Date(val).toISOString() : ""
            }));
          }}
          className="w-full"
        />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.personal_data.fields.nationality.label")}
        </label>
        <Select
          disabled={readOnly}
          value={profile?.nationality}
          onValueChange={(value) =>
            setProfile((prev: any) => ({ ...prev, nationality: value }))
          }
        >
          <SelectTrigger loading={loading}>
            <SelectValue
              placeholder={t(
                "forms.sections.personal_data.fields.nationality.placeholder"
              )}
            />
          </SelectTrigger>
          <SelectContent>
            {COUNTRY_OPTIONS.map((country) => (
              <SelectItem key={country.value} value={country.value}>
                {country.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
}
